/**
 * REST API client for comments.
 * Comments via dash-api REST.
 */

const BASE = process.env.REACT_APP_AWP_API_URL || 'https://awp.minsky.ai';

function authHeaders() {
    const token = localStorage.getItem('access_token');
    return token
        ? {'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json'}
        : {'Content-Type': 'application/json'};
}

export async function listComments(elementName, elementId) {
    const resp = await fetch(
        `${BASE}/api/comments/${encodeURIComponent(elementName)}/${encodeURIComponent(elementId)}`,
        {headers: authHeaders()}
    );
    if (!resp.ok) throw new Error(`listComments ${resp.status}`);
    return resp.json();
}

export async function getCommentsCount(elementName, elementId) {
    const resp = await fetch(
        `${BASE}/api/comments/${encodeURIComponent(elementName)}/${encodeURIComponent(elementId)}/count`,
        {headers: authHeaders()}
    );
    if (!resp.ok) throw new Error(`getCommentsCount ${resp.status}`);
    const data = await resp.json();
    return data.count ?? 0;
}

export async function createComment(elementName, elementId, {content, userId, userDisplayName, imageUrl}) {
    const body = {content, userId, userDisplayName, publishedDatetime: Date.now()};
    if (imageUrl) body.imageUrl = imageUrl;
    const resp = await fetch(
        `${BASE}/api/comments/${encodeURIComponent(elementName)}/${encodeURIComponent(elementId)}`,
        {
            method: 'POST',
            headers: authHeaders(),
            body: JSON.stringify(body),
        }
    );
    if (!resp.ok) throw new Error(`createComment ${resp.status}`);
    return resp.json();
}

export async function deleteComment(elementName, elementId, messageId) {
    const resp = await fetch(
        `${BASE}/api/comments/${encodeURIComponent(elementName)}/${encodeURIComponent(elementId)}/${messageId}`,
        {method: 'DELETE', headers: authHeaders()}
    );
    if (!resp.ok) throw new Error(`deleteComment ${resp.status}`);
}
